module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-help",
    style: ({
      'height': _vm.deviceHeight
    })
  }, [_c('div', {
    staticClass: "container",
    style: ({
      'height': _vm.containerHeight
    })
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "ui-listview edi-help-top order"
  }, [_c('li', [_c('h4', [_c('span', [_vm._v("订单可以二次订货吗?")])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("订单在发货后是不允许进行二次发货的，除非发货被拒绝，才可以进行发货处理。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "ui-listview"
  }, [_c('li', [_c('h4', [_c('span', [_vm._v("在接到订单时，第一步需做什么操作？")])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("刚接到订单时，需进行是否同意单据操作，同意后方可进行编辑和发货处理。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "ui-listview"
  }, [_c('li', [_c('h4', [_c('span', [_vm._v("同一个账号是否可以在多台设备同时登录？")])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("不可以。一个账号，同一时间只能在一台设备登录")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e91bff54!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Help.vue
// module id = 625
// module chunks = 1